import { render } from "./HomeTopBar.vue?vue&type=template&id=d8a453ae"
import script from "./HomeTopBar.vue?vue&type=script&lang=js"
export * from "./HomeTopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__